"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AisonFieldTransformer = AisonFieldTransformer;
const lodash_1 = require("lodash");
const defaultValues = {
    hidden: false,
    required: false,
    readonly: false,
    virtual: false,
    hide_legend: false,
    indexed: false,
};
function AisonFieldTransformer(options) {
    return (data) => {
        return Object.entries(data).reduce((acc, [key, value]) => ({
            ...acc,
            [key]: {
                ...defaultValues,
                legend: (0, lodash_1.startCase)((0, lodash_1.snakeCase)(key)),
                store_as: (0, lodash_1.snakeCase)(options.fields[key]?.legend || key),
                ...options.fields[key],
                ...(options.fields[key]?.data_type ? {} : fieldTypeFromValue(value)),
            },
        }), {});
    };
}
function fieldTypeFromValue(value) {
    if (value === null || value === undefined) {
        return { data_type: null };
    }
    if (value instanceof Date ||
        (typeof value == 'string' && !!Date.parse(value))) {
        return { data_type: 'DateTime' };
    }
    if (Array.isArray(value) || (0, lodash_1.isPlainObject)(value)) {
        return { data_type: 'Data' };
    }
    switch (typeof value) {
        case 'boolean':
            return { data_type: 'Toggle' };
        case 'number':
            const result = { data_type: 'Number' };
            if (Number.isInteger(value)) {
                result['format'] = '%d';
            }
            else if (value.toString().split('.')[1].length < 3) {
                result['format'] = '%.2f';
            }
            else {
                result['format'] = '%.3f';
            }
            return result;
        case 'string':
            return { data_type: 'Text' };
        default:
            return { data_type: 'UNKNOWN' };
    }
}
//# sourceMappingURL=aison-field-transformer.js.map